<div class="min-vh-100 bg-light py-5">
  <div class="container">
    <!-- Message Display Section -->
    <!-- Error Display -->
    <div class="row justify-content-center mb-4" *ngIf="currentMessage?.type === 'error'">
      <div class="col-12 col-lg-10 col-xl-8">
        <mat-card class="border-0 shadow-sm" style="background-color: #f8d7da; border-left: 4px solid #dc3545;">
          <mat-card-content class="p-3">
            <div class="d-flex align-items-start">
              <mat-icon class="me-2 mt-1" style="color: #dc3545;">error</mat-icon>
              <div class="flex-grow-1">
                <h6 class="fw-bold mb-1" style="color: #721c24;">{{ currentMessage?.title }}</h6>
                <p class="mb-2" style="color: #721c24;">{{ currentMessage?.message }}</p>
                <div class="mt-2" *ngIf="currentMessage?.canRetry">
                  <button type="button" 
                          mat-button 
                          color="warn" 
                          (click)="clearMessage()" 
                          class="me-2">
                    <mat-icon>close</mat-icon>
                    Dismiss
                  </button>
                </div>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    </div>

    <!-- Success Display -->
    <div class="row justify-content-center mb-4" *ngIf="currentMessage?.type === 'success'">
      <div class="col-12 col-lg-10 col-xl-8">
        <mat-card class="border-0 shadow-sm" style="background-color: #d1e7dd; border-left: 4px solid #198754;">
          <mat-card-content class="p-3">
            <div class="d-flex align-items-start">
              <mat-icon class="me-2 mt-1" style="color: #198754;">check_circle</mat-icon>
              <div class="flex-grow-1">
                <h6 class="fw-bold mb-1" style="color: #0f5132;">{{ currentMessage?.title }}</h6>
                <p class="mb-1" style="color: #0f5132;">{{ currentMessage?.message }}</p>
                <small class="text-muted">Redirecting you to your dashboard...</small>
                <div class="mt-2">
                  <mat-progress-bar mode="indeterminate" color="accent"></mat-progress-bar>
                </div>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    </div>

    <!-- Warning Display -->
    <div class="row justify-content-center mb-4" *ngIf="currentMessage?.type === 'warning'">
      <div class="col-12 col-lg-10 col-xl-8">
        <mat-card class="border-0 shadow-sm" style="background-color: #fff3cd; border-left: 4px solid #ffc107;">
          <mat-card-content class="p-3">
            <div class="d-flex align-items-start">
              <mat-icon class="me-2 mt-1" style="color: #ffc107;">warning</mat-icon>
              <div class="flex-grow-1">
                <h6 class="fw-bold mb-1" style="color: #664d03;">{{ currentMessage?.title }}</h6>
                <p class="mb-2" style="color: #664d03;">{{ currentMessage?.message }}</p>
                <div class="mt-2">
                  <button type="button" 
                          mat-button 
                          color="accent" 
                          (click)="clearMessage()">
                    <mat-icon>close</mat-icon>
                    Dismiss
                  </button>
                </div>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    </div>

    <!-- Multi-step Registration Component -->
    <app-multi-step-registration
      [firebaseUser]="firebaseUser"
      [isLoading]="isLoading"
      (registrationSubmit)="onRegistrationSubmit($event)"
      (cancel)="onCancel()">
    </app-multi-step-registration>
  </div>
</div>
